import { createTheme } from '@mui/material/styles';
import { PolcoColor } from './colors-class';

export const theme = createTheme({
  palette: {
    primary: { main: new PolcoColor('Jungle').hex },
  },
});
